import { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./whatsapp.scss"

import { Avatar, Dropdown, Modal, message } from "antd";
import { MoreOutlined, DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { deleteChat } from "../../../../../core/data/redux/slices/WabaChatSlice";
import api from "../../../../../core/axios/axiosInstance";
import { useSelector } from "react-redux";



const ChatWindow = ({ conversation, onOpenContact, messagePagination, onLoadMore, isLoadingMore }) => {
    const messagesContainerRef = useRef(null);
    const messagesEndRef = useRef(null);
    const prevScrollHeightRef = useRef(null);
    const isLoadingMoreRef = useRef(false);
      const userProfile = useSelector((state) => state.profile);
    // useEffect(() => {
    //     if (messagesEndRef.current) {
    //         messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    //     }
    // }, [conversation?.messages]); // Trigger on new messages
    useEffect(() => {
        const container = messagesContainerRef.current;
        if (!container) return;

        if (prevScrollHeightRef.current !== null) {
            // Restore scroll position after prepend
            container.scrollTop = container.scrollHeight - prevScrollHeightRef.current;
            prevScrollHeightRef.current = null;
        } else {
            // New message arrived or chat switched — scroll to bottom
            messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [conversation?.messages]);



    const handleLoadMoreClick = async () => {
        const container = messagesContainerRef.current;
        if (container) {
            prevScrollHeightRef.current = container.scrollHeight; // 👈 save BEFORE fetch
        }
        isLoadingMoreRef.current = true;
        await onLoadMore(); // calls the parent's handleLoadMore
        isLoadingMoreRef.current = false;
    };


    const dispatch = useDispatch();

    const [fullscreenImage, setFullscreenImage] = useState(null);
    const [clickedButtons, setClickedButtons] = useState({});


    useEffect(() => {
        if (messagesContainerRef.current) {
            messagesContainerRef.current.scrollTop =
                messagesContainerRef.current.scrollHeight;
        }
    }, [conversation?.id]);



    const handleDeleteChat = () => {
        Modal.confirm({
            title: "Delete Chat",
            icon: <ExclamationCircleOutlined />,
            content: "Are you sure you want to delete this chat?",
            okText: "Yes, Delete",
            okType: "danger",
            cancelText: "Cancel",
            onOk: async () => {
                try {
                    console.log(conversation.id, "hjgfdghvjb");
                    const payload = {
                        conversationIds: [conversation.id]
                    }
                    await api.delete("/api/whatsapp/delete-chats", {
                        data: payload,
                    });


                    dispatch(deleteChat(conversation.id));

                    message.success("Chat deleted successfully");
                } catch (error) {
                    console.error("Delete failed", error);
                    message.error("Failed to delete chat");
                }
            },
        });
    };


    const getMsgTick = (status, from) => {
        if (from !== "agent") return null;
        if (status === "read") {
            return (
                <svg viewBox="0 0 16 11" width="16" height="11" style={{ display: "inline" }}>
                    <path d="M11.071.653a.5.5 0 0 0-.707.01L4.801 6.517 2.647 4.361a.5.5 0 1 0-.707.707l2.5 2.5a.5.5 0 0 0 .712-.005l5.924-6.204a.5.5 0 0 0-.005-.706z" fill="#53bdeb"/>
                    <path d="M14.571.653a.5.5 0 0 0-.707.01L8.301 6.517l-.91-.91-.707.707 1.263 1.263a.5.5 0 0 0 .712-.005l5.924-6.204a.5.5 0 0 0-.012-.715z" fill="#53bdeb"/>
                </svg>
            );
        }
        if (status === "delivered") {
            return (
                <svg viewBox="0 0 16 11" width="16" height="11" style={{ display: "inline" }}>
                    <path d="M11.071.653a.5.5 0 0 0-.707.01L4.801 6.517 2.647 4.361a.5.5 0 1 0-.707.707l2.5 2.5a.5.5 0 0 0 .712-.005l5.924-6.204a.5.5 0 0 0-.005-.706z" fill="#8696a0"/>
                    <path d="M14.571.653a.5.5 0 0 0-.707.01L8.301 6.517l-.91-.91-.707.707 1.263 1.263a.5.5 0 0 0 .712-.005l5.924-6.204a.5.5 0 0 0-.012-.715z" fill="#8696a0"/>
                </svg>
            );
        }
        if (status === "sent") {
            return (
                <svg viewBox="0 0 10 11" width="10" height="11" style={{ display: "inline" }}>
                    <path d="M9.071.653a.5.5 0 0 0-.707.01L2.801 6.517.647 4.361a.5.5 0 1 0-.707.707l2.5 2.5a.5.5 0 0 0 .712-.005L9.076 1.36a.5.5 0 0 0-.005-.706z" fill="#8696a0"/>
                </svg>
            );
        }
        if (status === "failed") {
            return <span style={{ color: "#e53935", fontSize: 12, fontWeight: 700 }}>!</span>;
        }
        return null;
    };

    const getDocIcon = (mime) => {
        if (!mime) return "📎";
        if (mime.includes("pdf")) return "📄";
        if (mime.includes("word")) return "📝";
        if (mime.includes("excel") || mime.includes("spreadsheet")) return "📊";
        if (mime.includes("presentation")) return "📽";
        if (mime.includes("zip") || mime.includes("rar")) return "📦";
        return "📎";
    };
    const avatarSrc =
        typeof conversation?.image === "string" && conversation.image.trim() !== ""
            ? conversation.image
            : undefined;

    return (
        <div className="chat-window">
            {conversation ? (
                <>
                    <div className="chat-header">
                        <div className="chat-header-left" onClick={onOpenContact}>

                            <Avatar src={avatarSrc} size={40}>
                                {(conversation?.chatName || conversation?.originalName || conversation?.from || "?").charAt(0)}
                            </Avatar>
                            <div>
                                <strong>{conversation?.chatName || conversation?.originalName || conversation?.from}</strong>
                                <div className="chat-phone">{conversation?.phone}</div>
                            </div>
                        </div>
                        {userProfile.role=="companyAdmin" &&<Dropdown
                            menu={{
                                items: [
                                    {
                                        key: "delete",
                                        label: "Delete Chat",
                                        icon: <DeleteOutlined />,
                                        danger: true,
                                        onClick: handleDeleteChat,
                                    },
                                ],
                            }}
                            trigger={["click"]}
                        >
                            <MoreOutlined
                                style={{
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    padding: "5px",
                                }}
                            />
                        </Dropdown>}

                    </div>


                    <div className="chat-messages" ref={messagesContainerRef}>
                        {/* Load More Button */}
                        {messagePagination?.hasMore && (
                            <div style={{ textAlign: "center", padding: "10px 0" }}>
                                <button
                                    className="btn btn-sm btn-secondary"
                                    onClick={handleLoadMoreClick}
                                    disabled={isLoadingMore}
                                >
                                    {isLoadingMore ? "Loading..." : "Load older messages"}
                                </button>
                            </div>
                        )}

                        {conversation?.messages?.map((msg) => {
                

                            return (

                                <div
                                    key={msg?.id}
                                    className={`message ${msg?.from === "agent" ? "sent" : "received"}`}
                                >
                                    {msg.type === "text" && typeof msg.text === "string" && (
                                        <span>{msg.text}</span>
                                    )}
                                    {msg.type === "image" && msg.media?.url && (
                                        <>
                                            <img
                                                src={msg.media.url}
                                                alt="received"
                                                className="chat-image"
                                                onClick={() => setFullscreenImage(msg.media.url)}
                                            />
                                            <div>{msg.media.attachmentCaption}</div>
                                        </>
                                    )}

                                    {fullscreenImage && (
                                        <div className="fullscreen-modal">
                                            <button className="close-btn" onClick={() => setFullscreenImage(null)}>
                                                ✕
                                            </button>
                                            <a href={fullscreenImage} download className="download-btn">
                                                ⬇
                                            </a>
                                            <img src={fullscreenImage} alt="fullscreen" className="fullscreen-img" />
                                        </div>
                                    )}

                                    {msg.type === "video" && msg.media?.url && (
                                        <> <video controls className="chat-video">
                                            <source src={msg.media.url} type={msg.media.mimeType} />
                                        </video>
                                            <div>{msg.media.attachmentCaption}</div>
                                        </>
                                    )}
                                    {msg.type === "audio" && msg.media?.url && (
                                        <>  <audio controls src={msg.media.url} />
                                            <div>{msg.media.attachmentCaption}</div>
                                        </>
                                    )}
                                    {msg.type === "document" && msg.media?.url && (
                                        <> <a href={msg.media.url} target="_blank" rel="noreferrer">
                                            {getDocIcon(msg.media.mimeType)} {msg.media.attachmentName || msg.media.fileName}
                                        </a>
                                            <div>{msg.media.attachmentCaption}</div>
                                        </>
                                    )}

                                    {msg.type === "location" &&
                                        msg.location?.latitude &&
                                        msg.location?.longitude && (
                                            <div className="location-card">
                                                <a
                                                    href={`https://www.google.com/maps?q=${msg.location.latitude},${msg.location.longitude}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <img
                                                        className="location-map"
                                                        src={`https://maps.wikimedia.org/img/osm-intl,15,${msg.location.latitude},${msg.location.longitude},300x160.png`}
                                                        alt="location"
                                                    />
                                                </a>

                                                <div className="location-info">
                                                    <strong>{msg.location.name || "Location"}</strong>

                                                    {msg.location.address && (
                                                        <div className="location-address">
                                                            {msg.location.address}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                    {msg.type === "contacts" &&
                                        Array.isArray(msg.contacts) &&
                                        msg.contacts.map((c, i) => (
                                            <div key={i} className="contact-card">
                                                <Avatar size={36}>
                                                    {c.name?.charAt(0)}
                                                </Avatar>

                                                <div className="contact-info">
                                                    <strong>{c.name}</strong>

                                                    {Array.isArray(c.phones) &&
                                                        c.phones.map((p, j) => (
                                                            <div key={j} className="contact-phone">
                                                                {p.phone}
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                        ))}

                                    {msg.type === "template" && (
                                        <div className="template-message w-100">
                                            {msg.template?.components.map((c, i) => {
                                                /* ---------- HEADER ---------- */
                                                if (c.type === "HEADER") {
                                                    const format = c.format?.toLowerCase();
                                                    const media = c.media;

                                                    if (format === "text") {
                                                        return (
                                                            <div key={i} className="template-header">
                                                                <strong>{c.text}</strong>
                                                            </div>
                                                        );
                                                    }

                                                    if (format === "image" && media?.s3Url) {
                                                        return (
                                                            <img
                                                                key={i}
                                                                src={media.s3Url}
                                                                alt="template header"
                                                                className="template-header-image"
                                                                onClick={() => setFullscreenImage(media.s3Url)}
                                                            />
                                                        );
                                                    }

                                                    if (format === "video" && media?.s3Url) {
                                                        return (
                                                            <video
                                                                key={i}
                                                                controls
                                                                className="template-header-video"
                                                            >
                                                                <source src={media.s3Url} type={media.mimeType} />
                                                            </video>
                                                        );
                                                    }

                                                    if (format === "document") {
                                                        return (
                                                            <div key={i} className="template-header-document">
                                                                📄 {media?.fileName || "Document"}
                                                            </div>
                                                        );
                                                    }
                                                }

                                                /* ---------- BODY ---------- */
                                                if (c.type === "BODY") {
                                                    return (
                                                        <div key={i} className="template-body">
                                                            {c.text}
                                                        </div>
                                                    );
                                                }

                                                /* ---------- FOOTER ---------- */
                                                if (c.type === "FOOTER") {
                                                    return (
                                                        <div key={i} className="template-footer">
                                                            {c.text}
                                                        </div>
                                                    );
                                                }

                                                return null;
                                            })}
                                        </div>
                                    )}

                                    {msg?.template?.components
                                        .filter(c => c.type === "BUTTONS")
                                        .map((c, i) => (
                                            <div key={i} className="wa-template-actions">
                                                {c.buttons.map((btn, j) => {
                                                    const key = `${msg.id}-${i}-${j}`;
                                                    const isClicked = clickedButtons[key];

                                                    const getBtnIcon = () => {
                                                        const t = (btn.type || "").toUpperCase();
                                                        if (t === "URL") return "🔗 ";
                                                        if (t === "PHONE_NUMBER") return "📞 ";
                                                        if (t === "QUICK_REPLY") return "↩️ ";
                                                        if (t === "COPY_CODE") return "📋 ";
                                                        return "";
                                                    };

                                                    const handleClick = () => {
                                                        setClickedButtons(prev => ({ ...prev, [key]: true }));

                                                        // Optional: handle actions
                                                        const t = (btn.type || "").toUpperCase();

                                                        if (t === "URL" && btn.url) window.open(btn.url, "_blank");
                                                        if (t === "PHONE_NUMBER" && btn.phone_number) window.open(`tel:${btn.phone_number}`);
                                                        // QUICK_REPLY usually just sends text back — depends on your backend
                                                    };

                                                    return (
                                                        <button
                                                            key={j}
                                                            type="button"
                                                            className={`wa-template-action-btn ${isClicked ? "clicked" : ""}`}
                                                            onClick={handleClick}
                                                            disabled={isClicked}
                                                        >
                                                            <span className="wa-btn-inner">
                                                                {getBtnIcon() && <span className="wa-btn-icon">{getBtnIcon()}</span>}
                                                                <span className="wa-btn-text">{btn.text}</span>
                                                            </span>
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        ))}


                                    <div className="d-flex justify-content-between align-items-center"><div className="time me-2">{msg.date} || {msg.time}</div>
                                        <div className="time" style={{ lineHeight: 1 }}>{getMsgTick(msg.status, msg.from)}</div></div>
                                </div>)
                        })}
                        <div ref={messagesEndRef} />
                    </div>
                </>
            )



                :
                <div>
                    <img
                        src="/assets/img/icons/whatsappIcon96.png"
                        alt="WhatsApp Business"
                        className="empty-image"
                    />
                    <h2 className="pb-2">Welcome to Your Business Inbox</h2>
                    <p>
                        Select a conversation to start messaging your customers. <br />
                        All your chats will appear here once selected.
                    </p>
                </div>
            }
        </div>
    );
};
export default ChatWindow;